import paths from "@/lib/legacy-flight-paths.json";
import { isValidFlightRoute } from "@/lib/flight-route-policy";

const redirects: Readonly<Record<string, string>> = paths;
export function resolveLegacyFlightPath(path: string): string | null {
  const key = path.replace(/\/+$/, "") || "/";
  const target = redirects[key];
  if (!target) return null;
  const pair = /^\/loty\/([a-z]{3})\/([a-z]{3})$/.exec(target);
  if (pair && !isValidFlightRoute(pair[1], pair[2])) return null;
  return pair ? `/loty/${pair[1] === "war" ? "waw" : pair[1]}/${pair[2] === "war" ? "waw" : pair[2]}` : target;
}